import React, { useState, useEffect } from 'react';
import axios from './lib/axiosClient';

function ClientPhotos() {
  var [photos, setPhotos] = useState([]);
  var [customers, setCustomers] = useState([]);
  var [filter, setFilter] = useState('all');
  var [filterContact, setFilterContact] = useState('');
  var [showUpload, setShowUpload] = useState(false);
  var [loading, setLoading] = useState(true);
  var [form, setForm] = useState({ contact_id: '', photo_type: 'after', photo_url: '', notes: '', service_name: '' });
  var [preview, setPreview] = useState(null);

  useEffect(function() { loadAll(); }, []);

  var loadAll = async function() {
    try {
      var [pRes, cRes] = await Promise.all([
        axios.get('/api/client-photos'),
        axios.get('/api/customers'),
      ]);
      setPhotos(pRes.data.photos || []);
      setCustomers(cRes.data.customers || []);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  var handleFileSelect = function(e) {
    var file = e.target.files[0];
    if (!file) return;
    var reader = new FileReader();
    reader.onload = function(ev) {
      setForm(function(f) { return { ...f, photo_url: ev.target.result }; });
    };
    reader.readAsDataURL(file);
  };

  var handleUpload = async function() {
    if (!form.contact_id || !form.photo_url) { alert('Select a customer and add a photo'); return; }
    try {
      await axios.post('/api/client-photos', {
        contact_id: form.contact_id,
        photo_type: form.photo_type,
        photo_url: form.photo_url,
        notes: form.notes,
        service_name: form.service_name,
      });
      setForm({ contact_id: '', photo_type: 'after', photo_url: '', notes: '', service_name: '' });
      setShowUpload(false);
      loadAll();
    } catch (err) { alert('Error uploading photo'); }
  };

  var handleDelete = async function(id) {
    if (!window.confirm('Delete this photo?')) return;
    try {
      await axios.delete('/api/client-photos/' + id);
      setPhotos(function(p) { return p.filter(function(x) { return x.id !== id; }); });
    } catch (err) { console.error(err); }
  };

  var filtered = photos.filter(function(p) {
    if (filter !== 'all' && p.photo_type !== filter) return false;
    if (filterContact && p.contact_id !== parseInt(filterContact)) return false;
    return true;
  });

  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh', color: '#888' }}>Loading gallery...</div>;

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto' }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <h1 style={{ fontSize: 26, fontWeight: 800, color: '#fff', margin: '0 0 6px' }}>📸 Client Photos</h1>
          <p style={{ fontSize: 14, color: '#888', margin: 0 }}>Before & after photos, progress tracking</p>
        </div>
        <button onClick={function() { setShowUpload(true); }} style={{
          padding: '12px 24px', background: 'linear-gradient(135deg, #ff6b2b, #ffab40)', border: 'none', borderRadius: 12,
          color: '#fff', fontSize: 14, fontWeight: 700, cursor: 'pointer',
        }}>+ Add Photo</button>
      </div>

      {/* Filters */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap', alignItems: 'center' }}>
        {['all', 'before', 'after', 'progress'].map(function(t) {
          return (
            <button key={t} onClick={function() { setFilter(t); }} style={{
              padding: '8px 16px', borderRadius: 8, border: 'none', fontSize: 13, fontWeight: 600, cursor: 'pointer',
              background: filter === t ? '#ff6b2b' : '#252840', color: filter === t ? '#fff' : '#888',
            }}>{t === 'all' ? 'All' : t.charAt(0).toUpperCase() + t.slice(1)}</button>
          );
        })}
        <select value={filterContact} onChange={function(e) { setFilterContact(e.target.value); }} style={{
          padding: '8px 14px', borderRadius: 8, background: '#252840', border: '1px solid #2a2a4a',
          color: '#fff', fontSize: 13, marginLeft: 'auto',
        }}>
          <option value="">All Customers</option>
          {customers.map(function(c) {
            return <option key={c.id} value={c.id}>{c.first_name} {c.last_name}</option>;
          })}
        </select>
      </div>

      {/* Gallery Grid */}
      {filtered.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 60, background: '#12121f', borderRadius: 16, border: '1px solid #1e1e35' }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>📷</div>
          <div style={{ color: '#fff', fontSize: 18, fontWeight: 600 }}>No photos yet</div>
          <div style={{ color: '#888', fontSize: 14, marginTop: 8 }}>Add before & after photos to showcase your work</div>
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: 16 }}>
          {filtered.map(function(photo) {
            var typeColors = { before: '#f59e0b', after: '#10b981', progress: '#8b5cf6' };
            return (
              <div key={photo.id} style={{ background: '#12121f', borderRadius: 14, overflow: 'hidden', border: '1px solid #1e1e35' }}>
                <div style={{ position: 'relative', cursor: 'pointer' }} onClick={function() { setPreview(photo); }}>
                  <img src={photo.photo_url} alt="" style={{ width: '100%', height: 200, objectFit: 'cover' }} />
                  <span style={{
                    position: 'absolute', top: 10, left: 10, padding: '4px 10px', borderRadius: 6,
                    background: typeColors[photo.photo_type] || '#888', color: '#fff', fontSize: 11, fontWeight: 700, textTransform: 'uppercase',
                  }}>{photo.photo_type}</span>
                </div>
                <div style={{ padding: 14 }}>
                  <div style={{ color: '#fff', fontWeight: 600, fontSize: 14 }}>
                    {photo.contacts?.first_name} {photo.contacts?.last_name}
                  </div>
                  {photo.service_name && <div style={{ color: '#888', fontSize: 12, marginTop: 2 }}>{photo.service_name}</div>}
                  {photo.notes && <div style={{ color: '#aaa', fontSize: 12, marginTop: 6, fontStyle: 'italic' }}>{photo.notes}</div>}
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 10 }}>
                    <span style={{ color: '#555', fontSize: 11 }}>{new Date(photo.created_at).toLocaleDateString()}</span>
                    <button onClick={function(e) { e.stopPropagation(); handleDelete(photo.id); }} style={{
                      background: 'none', border: 'none', color: '#555', fontSize: 12, cursor: 'pointer',
                    }}>🗑️</button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Preview Modal */}
      {preview && (
        <div onClick={function() { setPreview(null); }} style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.9)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999, padding: 20,
        }}>
          <div onClick={function(e) { e.stopPropagation(); }} style={{ maxWidth: 700, width: '100%' }}>
            <img src={preview.photo_url} alt="" style={{ width: '100%', borderRadius: 12 }} />
            <div style={{ padding: '16px 0' }}>
              <div style={{ color: '#fff', fontSize: 18, fontWeight: 700 }}>
                {preview.contacts?.first_name} {preview.contacts?.last_name}
              </div>
              {preview.service_name && <div style={{ color: '#ffab40', fontSize: 14, marginTop: 4 }}>{preview.service_name}</div>}
              {preview.notes && <div style={{ color: '#aaa', fontSize: 14, marginTop: 8 }}>{preview.notes}</div>}
            </div>
          </div>
        </div>
      )}

      {/* Upload Modal */}
      {showUpload && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.7)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999, padding: 20,
        }}>
          <div style={{ background: '#12121f', borderRadius: 20, padding: 28, maxWidth: 460, width: '100%', border: '1px solid #1e1e35' }}>
            <h2 style={{ color: '#fff', fontSize: 20, fontWeight: 700, marginBottom: 20 }}>📸 Add Photo</h2>

            <label style={s.label}>Customer *</label>
            <select value={form.contact_id} onChange={function(e) { setForm(function(f) { return { ...f, contact_id: e.target.value }; }); }} style={s.input}>
              <option value="">Select customer...</option>
              {customers.map(function(c) { return <option key={c.id} value={c.id}>{c.first_name} {c.last_name}</option>; })}
            </select>

            <label style={s.label}>Photo Type</label>
            <div style={{ display: 'flex', gap: 8, marginBottom: 14 }}>
              {['before', 'after', 'progress'].map(function(t) {
                return (
                  <button key={t} onClick={function() { setForm(function(f) { return { ...f, photo_type: t }; }); }} style={{
                    flex: 1, padding: '10px', borderRadius: 8, border: form.photo_type === t ? '2px solid #ff6b2b' : '1px solid #2a2a4a',
                    background: form.photo_type === t ? '#ff6b2b15' : '#252840', color: form.photo_type === t ? '#ff6b2b' : '#888',
                    fontSize: 13, fontWeight: 600, cursor: 'pointer', textTransform: 'capitalize',
                  }}>{t}</button>
                );
              })}
            </div>

            <label style={s.label}>Photo *</label>
            <input type="file" accept="image/*" onChange={handleFileSelect} style={{ ...s.input, padding: 10 }} />
            {form.photo_url && form.photo_url.startsWith('data:') && (
              <img src={form.photo_url} alt="preview" style={{ width: '100%', height: 160, objectFit: 'cover', borderRadius: 10, marginBottom: 14 }} />
            )}

            <label style={s.label}>Service Name (optional)</label>
            <input value={form.service_name} onChange={function(e) { setForm(function(f) { return { ...f, service_name: e.target.value }; }); }}
              placeholder="e.g. Microneedling, Sleeve Tattoo" style={s.input} />

            <label style={s.label}>Notes (optional)</label>
            <input value={form.notes} onChange={function(e) { setForm(function(f) { return { ...f, notes: e.target.value }; }); }}
              placeholder="Session 3 of 6, healing well..." style={s.input} />

            <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
              <button onClick={function() { setShowUpload(false); }} style={{ flex: 1, padding: 14, borderRadius: 10, border: '1px solid #333', background: 'transparent', color: '#888', cursor: 'pointer', fontWeight: 600 }}>Cancel</button>
              <button onClick={handleUpload} style={{ flex: 1, padding: 14, borderRadius: 10, border: 'none', background: 'linear-gradient(135deg, #ff6b2b, #ffab40)', color: '#fff', cursor: 'pointer', fontWeight: 700 }}>Upload Photo</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

var s = {
  label: { display: 'block', color: '#aaa', fontSize: 12, fontWeight: 600, marginBottom: 6 },
  input: { width: '100%', padding: '12px 14px', background: '#252840', border: '1px solid #2a2a4a', borderRadius: 10, color: '#fff', fontSize: 14, outline: 'none', boxSizing: 'border-box', marginBottom: 14 },
};

export default ClientPhotos;
